
(() => {
  const lockPage = (locked) => {
    document.documentElement.classList.toggle('mmg-search-lock', locked);
    document.body?.classList.toggle('mmg-search-lock', locked);
  };

  const resetDialog = (dialog) => {
    const input = dialog.querySelector('input[type="search"]');
    const resetButton = dialog.querySelector('button[type="reset"]');
    const predictive = dialog.querySelector('predictive-search');
    const results = dialog.querySelector('[data-predictive-search]');
    const status = dialog.querySelector('.predictive-search-status');

    if (input) {
      input.value = '';
      input.removeAttribute('aria-activedescendant');
      input.setAttribute('aria-expanded', 'false');
    }

    resetButton?.classList.add('hidden');

    if (predictive) {
      try {
        predictive.abortController?.abort();
      } catch (_) {}

      if ('AbortController' in window) {
        predictive.abortController = new AbortController();
      }

      predictive.searchTerm = '';
      predictive.isOpen = false;
      predictive.resultsMaxHeight = false;
      predictive.removeAttribute('open');
      predictive.removeAttribute('results');
      predictive.removeAttribute('loading');

      if (typeof predictive.closeResults === 'function') {
        predictive.closeResults(true);
      }
    }

    if (results) {
      results.innerHTML = '';
      results.removeAttribute('style');
    }

    if (status) {
      status.textContent = '';
      status.setAttribute('aria-hidden', 'true');
    }
  };

  const focusInput = (dialog) => {
    const input = dialog.querySelector('input[type="search"]');
    if (!input) return;

    window.setTimeout(() => {
      input.focus({ preventScroll: true });
      input.setSelectionRange?.(0, 0);
    }, 60);
  };

  const openDialog = (dialog) => {
    resetDialog(dialog);

    if (!dialog.open) {
      dialog.showModal();
    }

    lockPage(true);
    focusInput(dialog);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.mmg-search-trigger');
    if (trigger) {
      const id = trigger.getAttribute('aria-controls');
      const dialog = id ? document.getElementById(id) : null;
      if (dialog instanceof HTMLDialogElement) {
        event.preventDefault();
        openDialog(dialog);
      }
      return;
    }

    const close = event.target.closest('[data-mmg-search-close]');
    if (close) {
      const dialog = close.closest('dialog');
      if (dialog instanceof HTMLDialogElement) {
        dialog.close();
      }
      return;
    }

    const quickQuery = event.target.closest('[data-mmg-search-query]');
    if (quickQuery) {
      const dialog = quickQuery.closest('dialog');
      const input = dialog?.querySelector('input[type="search"]');
      if (!input) return;

      input.value = quickQuery.dataset.mmgSearchQuery || '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus({ preventScroll: true });
    }
  });

  document.addEventListener('click', (event) => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement) || !dialog.classList.contains('mmg-search-dialog')) return;

    const rect = dialog.querySelector('.mmg-search-dialog__panel')?.getBoundingClientRect();
    if (!rect) return;

    const outside =
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom;

    if (outside && window.matchMedia('(min-width: 750px)').matches) {
      dialog.close();
    }
  });

  document.addEventListener('close', (event) => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement) || !dialog.classList.contains('mmg-search-dialog')) return;

    resetDialog(dialog);
    lockPage(false);

    const trigger = document.querySelector(`[aria-controls="${CSS.escape(dialog.id)}"]`);
    trigger?.focus({ preventScroll: true });
  }, true);

  document.addEventListener('keydown', (event) => {
    const shortcut =
      (event.metaKey || event.ctrlKey) &&
      event.key.toLowerCase() === 'k';

    if (!shortcut) return;

    const trigger = document.querySelector('.mmg-search-trigger');
    const id = trigger?.getAttribute('aria-controls');
    const dialog = id ? document.getElementById(id) : null;

    if (!(dialog instanceof HTMLDialogElement)) return;

    event.preventDefault();

    if (dialog.open) {
      resetDialog(dialog);
      focusInput(dialog);
    } else {
      openDialog(dialog);
    }
  });

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.mmg-search-dialog').forEach((dialog) => {
      if (!(dialog instanceof HTMLDialogElement)) return;
      if (dialog.open) dialog.close();
      resetDialog(dialog);
    });
    lockPage(false);
  });
})();
